(function () {
  'use strict';

  var READY_ATTR = 'data-vote-ready';
  var DEVICE_HASH_KEY = 'lesensier:device-hash';
  var VOTED_KEY_PREFIX = 'lesensier:voted:';

  function generateUuidV4() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
      var random = (Math.random() * 16) | 0;
      var value = character === 'x' ? random : (random & 0x3) | 0x8;
      return value.toString(16);
    });
  }

  function getDeviceHash() {
    try {
      var existing = window.localStorage.getItem(DEVICE_HASH_KEY);
      if (existing) return existing;
      var hash = generateUuidV4();
      window.localStorage.setItem(DEVICE_HASH_KEY, hash);
      return hash;
    } catch (_) {
      return generateUuidV4();
    }
  }

  function readStoredOptionIds(campaignId) {
    try {
      var stored = window.localStorage.getItem(VOTED_KEY_PREFIX + campaignId);
      if (!stored) return [];
      if (stored.charAt(0) === '[') {
        var parsed = JSON.parse(stored);
        return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
      }
      return [stored];
    } catch (_) {
      return [];
    }
  }

  function writeStoredOptionIds(campaignId, optionIds, voteMode) {
    try {
      var value = voteMode === 'multi' ? JSON.stringify(optionIds) : optionIds[0];
      window.localStorage.setItem(VOTED_KEY_PREFIX + campaignId, value);
    } catch (_) {}
  }

  function VoteInstance(root) {
    this.root = root;
    this.campaignId = root.getAttribute('data-campaign-id') || '';
    this.webhookUrl = root.getAttribute('data-webhook-url') || '';
    this.tallyUrl = root.getAttribute('data-tally-url') || '';
    this.webhookSecret = root.getAttribute('data-webhook-secret') || '';
    this.voteMode = root.getAttribute('data-vote-mode') === 'multi' ? 'multi' : 'single';
    this.minSelections = Math.max(1, parseInt(root.getAttribute('data-min-selections'), 10) || 1);
    this.maxSelections = Math.max(this.minSelections, parseInt(root.getAttribute('data-max-selections'), 10) || 1);
    this.errorMessage = root.getAttribute('data-error-message') || 'Não foi possível registrar, tente novamente.';
    this.limitMessage = root.getAttribute('data-limit-message') || 'Você pode escolher até {max} opções.';
    this.selectionMessage = root.getAttribute('data-selection-message') || 'Escolha pelo menos {min} opção.';
    this.errorEl = root.querySelector('[data-vote-error]');
    this.statusEl = root.querySelector('[data-vote-status]');
    this.submitButton = root.querySelector('[data-vote-submit]');
    this.selectedOptionIds = [];
    this.hasVoted = false;
    this.submitting = false;

    this.bind();
    this.applyStoredVoteState();
    this.updateMultiControls();
    this.fetchTally();
  }

  VoteInstance.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (event) {
      var target = event.target;
      var optionButton = target && target.closest ? target.closest('[data-vote-option]') : null;
      var submitButton = target && target.closest ? target.closest('[data-vote-submit]') : null;

      if (optionButton && self.root.contains(optionButton)) {
        event.preventDefault();
        if (self.voteMode === 'multi') self.toggleOption(optionButton);
        else self.submitSingle(optionButton);
      } else if (submitButton && self.root.contains(submitButton)) {
        event.preventDefault();
        self.submitMultiple();
      }
    });
  };

  VoteInstance.prototype.getOptionButtons = function () {
    return Array.prototype.slice.call(this.root.querySelectorAll('[data-vote-option]'));
  };

  VoteInstance.prototype.getCard = function (optionId) {
    return Array.prototype.find.call(this.root.querySelectorAll('[data-vote-card]'), function (card) {
      return card.getAttribute('data-option-id') === optionId;
    }) || null;
  };

  VoteInstance.prototype.buildHeaders = function (includeContentType) {
    var headers = {};
    if (includeContentType) headers['Content-Type'] = 'application/json';
    if (this.webhookSecret) headers['X-Vote-Secret'] = this.webhookSecret;
    return headers;
  };

  VoteInstance.prototype.setOptionButtonsDisabled = function (disabled) {
    this.getOptionButtons().forEach(function (button) {
      button.disabled = disabled;
    });
  };

  VoteInstance.prototype.applyStoredVoteState = function () {
    var storedOptionIds = readStoredOptionIds(this.campaignId);
    if (!storedOptionIds.length) return;
    this.hasVoted = true;
    this.selectedOptionIds = storedOptionIds;
    this.markVotedUI(storedOptionIds);
  };

  VoteInstance.prototype.markVotedUI = function (optionIds) {
    this.getOptionButtons().forEach(function (button) {
      var optionId = button.getAttribute('data-option-id');
      var selected = optionIds.indexOf(optionId) !== -1;
      var card = button.closest('[data-vote-card]');
      button.disabled = true;
      button.setAttribute('aria-pressed', String(selected));
      if (card) {
        card.classList.toggle('is-selected', selected);
        card.classList.toggle('is-voted', selected);
      }
      if (selected) button.textContent = button.getAttribute('data-voted-label') || button.textContent;
    });
    if (this.submitButton) {
      this.submitButton.disabled = true;
      this.submitButton.hidden = true;
    }
    this.updateSelectionStatus();
  };

  VoteInstance.prototype.updateSelectionStatus = function () {
    if (!this.statusEl || this.voteMode !== 'multi') return;
    var template = this.root.getAttribute('data-count-message') || '{count} de {max} selecionadas';
    this.statusEl.textContent = template
      .replace('{count}', String(this.selectedOptionIds.length))
      .replace('{max}', String(this.maxSelections));
  };

  VoteInstance.prototype.updateMultiControls = function () {
    if (this.voteMode !== 'multi' || this.hasVoted) return;
    var selectedOptionIds = this.selectedOptionIds;
    this.getOptionButtons().forEach(function (button) {
      var selected = selectedOptionIds.indexOf(button.getAttribute('data-option-id')) !== -1;
      var card = button.closest('[data-vote-card]');
      button.setAttribute('aria-pressed', String(selected));
      button.textContent = selected
        ? button.getAttribute('data-selected-label') || button.textContent
        : button.getAttribute('data-button-label') || button.textContent;
      if (card) card.classList.toggle('is-selected', selected);
    });
    if (this.submitButton) this.submitButton.disabled = selectedOptionIds.length < this.minSelections;
    this.updateSelectionStatus();
  };

  VoteInstance.prototype.toggleOption = function (button) {
    if (this.hasVoted || this.submitting) return;
    var optionId = button.getAttribute('data-option-id');
    if (!optionId) return;
    var currentIndex = this.selectedOptionIds.indexOf(optionId);

    this.hideError();
    if (currentIndex !== -1) {
      this.selectedOptionIds.splice(currentIndex, 1);
    } else if (this.selectedOptionIds.length < this.maxSelections) {
      this.selectedOptionIds.push(optionId);
    } else {
      this.showError(this.limitMessage.replace('{max}', String(this.maxSelections)));
    }
    this.updateMultiControls();
  };

  VoteInstance.prototype.extractTally = function (data) {
    if (!data) return [];
    if (Array.isArray(data.tally)) return data.tally;
    if (Array.isArray(data.options)) return data.options;
    if (Array.isArray(data)) return data;
    return [];
  };

  VoteInstance.prototype.paintTally = function (tally) {
    if (!tally || !tally.length) return;
    var total = tally.reduce(function (sum, row) {
      var count = parseInt(row && row.count, 10);
      return sum + (isNaN(count) ? 0 : count);
    }, 0);
    var self = this;

    tally.forEach(function (row) {
      var optionId = row && (row.option_id || row.optionId);
      var card = optionId ? self.getCard(optionId) : null;
      if (!card) return;
      var count = parseInt(row.count, 10);
      if (isNaN(count)) count = 0;
      var countElement = card.querySelector('[data-vote-count]');
      var barElement = card.querySelector('[data-vote-bar]');
      if (countElement) countElement.textContent = String(count);
      if (barElement) barElement.style.width = (total > 0 ? (count / total) * 100 : 0).toFixed(1) + '%';
    });
  };

  VoteInstance.prototype.fetchTally = function () {
    if (!this.tallyUrl || !this.campaignId) return;
    var self = this;
    var separator = this.tallyUrl.indexOf('?') > -1 ? '&' : '?';
    var url = this.tallyUrl + separator + 'campaign_id=' + encodeURIComponent(this.campaignId);

    fetch(url, { credentials: 'omit', headers: this.buildHeaders(false) })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) { if (data) self.paintTally(self.extractTally(data)); })
      .catch(function () {});
  };

  VoteInstance.prototype.showError = function (message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message || this.errorMessage;
    this.errorEl.hidden = false;
  };

  VoteInstance.prototype.hideError = function () {
    if (!this.errorEl) return;
    this.errorEl.hidden = true;
    this.errorEl.textContent = '';
  };

  VoteInstance.prototype.completeVote = function (optionIds) {
    this.hasVoted = true;
    this.selectedOptionIds = optionIds;
    writeStoredOptionIds(this.campaignId, optionIds, this.voteMode);
    this.markVotedUI(optionIds);
  };

  VoteInstance.prototype.sendVote = async function (payload, fallbackOptionIds) {
    this.submitting = true;
    this.hideError();
    this.setOptionButtonsDisabled(true);
    if (this.submitButton) this.submitButton.disabled = true;

    try {
      var response = await fetch(this.webhookUrl, {
        method: 'POST',
        headers: this.buildHeaders(true),
        credentials: 'omit',
        body: JSON.stringify(payload)
      });
      if (!response.ok) throw new Error('vote: http error ' + response.status);
      var data = await response.json();
      this.paintTally(this.extractTally(data));
      if (!data || (data.status !== 'counted' && data.status !== 'duplicate')) {
        throw new Error('vote: unexpected status ' + (data && data.status));
      }
      var selectedOptionIds = Array.isArray(data.selectedOptionIds) && data.selectedOptionIds.length
        ? data.selectedOptionIds
        : fallbackOptionIds;
      this.completeVote(selectedOptionIds);
    } catch (error) {
      this.setOptionButtonsDisabled(false);
      this.showError();
      this.updateMultiControls();
      if (window.console) window.console.error('[vote] falha ao registrar voto:', error);
    } finally {
      this.submitting = false;
    }
  };

  VoteInstance.prototype.submitSingle = function (button) {
    if (this.hasVoted || this.submitting) return;
    var optionId = button.getAttribute('data-option-id');
    var optionType = button.getAttribute('data-option-type');
    if (!optionId || !this.webhookUrl) return;

    this.sendVote({
      campaignId: this.campaignId,
      optionId: optionId,
      optionType: optionType,
      deviceHash: getDeviceHash(),
      timestamp: new Date().toISOString(),
      customerId: (window.Shopify && window.Shopify.customer && window.Shopify.customer.id) || null,
      email: null
    }, [optionId]);
  };

  VoteInstance.prototype.submitMultiple = function () {
    if (this.hasVoted || this.submitting || !this.webhookUrl) return;
    if (this.selectedOptionIds.length < this.minSelections) {
      this.showError(this.selectionMessage.replace('{min}', String(this.minSelections)));
      return;
    }
    this.sendVote({
      campaignId: this.campaignId,
      optionIds: this.selectedOptionIds.slice(),
      optionType: 'multi',
      deviceHash: getDeviceHash()
    }, this.selectedOptionIds.slice());
  };

  function initRoot(root) {
    if (!root || root.getAttribute(READY_ATTR) === 'true') return;
    root.setAttribute(READY_ATTR, 'true');
    try {
      new VoteInstance(root);
    } catch (error) {
      if (window.console) window.console.error('[vote] init failed:', error);
    }
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(context.querySelectorAll('[data-vote]'), initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });
})();
